"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEDevice = void 0;
const bluetooth_le_1 = require("@capacitor-community/bluetooth-le");
const events_1 = require("events");
const core_1 = require("@capacitor/core");
const c = __importStar(require("../lib/constants"));
class BLEDevice extends events_1.EventEmitter {
    constructor() {
        super();
        this.availableDevices = [];
        bluetooth_le_1.BleClient.initialize();
    }
    async connect(device) {
        await bluetooth_le_1.BleClient.connect(device.deviceId, (deviceId) => {
            console.log(`${deviceId} Disconnected`);
            this.emit('disconnected', deviceId);
            // TODO: implement exponential backoff
        });
        this.emit('connected', device.deviceId);
        this.device = device;
        return device;
    }
    async disconnect() {
        if (!this.device)
            throw Error('Not device connected');
        await bluetooth_le_1.BleClient.disconnect(this.device.deviceId);
    }
    async startScan(connect, deviceType) {
        const platform = core_1.Capacitor.getPlatform();
        console.log(platform);
        if (platform === 'web') {
            const device = await bluetooth_le_1.BleClient.requestDevice({
                // TODO: Fix
                // services: [c.INSAI_SERVICE, '0000fe8d-0000-1000-8000-00805f9b34fb', c.NEORHYTHM_SERVICE], //Muse equivalent UUID
                optionalServices: [c.NEORHYTHM_SERVICE_UUID, c.NEORHYTHM_SERVICE, c.INSAI_SERVICE, '0000fe8d-0000-1000-8000-00805f9b34fb'],
                namePrefix: deviceType,
            });
            this.availableDevices.push({ device });
            if (connect)
                return this.connect(device);
            return device;
        }
        else {
            await bluetooth_le_1.BleClient.requestLEScan({ namePrefix: deviceType }, async (device) => {
                // if (device.localName?.includes(deviceType)) {
                this.availableDevices.push(device);
                // TODO: auto connect
                // }
            });
        }
    }
    async stopScan() {
        await bluetooth_le_1.BleClient.stopLEScan();
        this.availableDevices = [];
    }
}
exports.BLEDevice = BLEDevice;
//# sourceMappingURL=bluetooth.js.map